<template>
    <div class="con">
    <div class="banner">
        <img src="../assets/yr/cbanner.png" alt="">
    </div>
        <div class="main">
            <div class="contact" >
                <p class="title">{{$t('list')[5]}}</p>
                <div class="lines">
                    <span></span>
                    <span class="t"></span>
                    <span></span>
                </div>
                <p class="t">{{$t('contact').text1}}
                    <span>{{$t('contact').text2}}</span>
                </p>
                <div class="mainInfo">
                    <div class="m1">
                        <div class="item">
                            <img src="../assets/about/one.png" alt="">
                            <p>{{$t('contact').text3}}</p>
                        </div>
                        <div class="item">
                            <img src="../assets/about/two.png" alt="">
                            <p>{{$t('contact').text4}}</p>
                        </div>
                        <div class="item">
                            <img src="../assets/about/four.png" alt="">
                            <p>0086-574-88219727　0086-574-88219707</p>
                        </div>
                        <div class="item">
                            <img src="../assets/cz.png" alt="">
                            <p>0086-574-83004156</p>
                        </div>
                        <div class="item">
                            <img src="../assets/xx.png" alt="">
                            <p> mary@yourtrustit.com </p>
                        </div>
                        <div class="item">
                            <img src="../assets/about/three.png" alt="">
                            <p>315131</p>
                        </div>
                    </div>

<!--                    <div class="item2">-->
<!--                        <div class="ia">-->
<!--                            <img src="../assets/about/four.png" alt="">-->
<!--                            <p>0089-574-88230892</p>-->
<!--                        </div>-->
<!--                        <div class="ia">-->
<!--                            <img src="../assets/cz.png" alt="">-->
<!--                            <p>0089-574-88230792</p>-->
<!--                        </div>-->
<!--                        <div class="ia">-->
<!--                            <img src="../assets/xx.png" alt="">-->
<!--                            <p> mary@yourtrustit.com </p>-->
<!--                        </div>-->
<!--                        <div class="ia">-->
<!--                            <img src="../assets/about/three.png" alt="">-->
<!--                            <p>315131</p>-->
<!--                        </div>-->
<!--                    </div>-->
                    <div class="form">
                        <input type="text" :placeholder="$t('form').text1" v-model="form.name">
                        <input type="text" :placeholder="$t('form').text2" v-model="form.email">
                        <input type="text" :placeholder="$t('form').text3" v-model="form.phone">
                        <input type="text" :placeholder="$t('form').text4" v-model="form.title">
                        <textarea :placeholder="$t('form').text5" v-model="form.content"></textarea>
                    </div>
                </div>
                <div class="btn2" @click="send">
                    <btn-Component :text="$t('btn2')"></btn-Component>
                </div>
            </div>
        </div>
        <foot-Component></foot-Component>
    </div>
</template>

<script>
    import  qs from 'qs'
    import footComponent from '../components/foot'
    import btnComponent from '../components/btn'
    export default {
        name: "about",
        data(){
            return{
                num:0,
                form:{
                    name:'',
                    email:'',
                    phone:'',
                    title:'',
                    content:''
                }
            }
        },
        components:{footComponent,btnComponent},
        mounted(){
            if(this.$route.query.index!==undefined){
                this.showRight(parseInt(this.$route.query.index))
            }
        },
        methods:{
            send(){
                if(this.form.email==='' || this.form.name==='' || this.form.phone==='' || this.form.title==='' || this.form.content===''){
                    this.$notify({
                        title: 'Prompt',
                        message: 'Please fill in the completed information',
                        offset: 100
                    });
                }else{
                    this.$nextTick(()=>{
                        const url ='/php/form.php'
                        this.$axios.post(url,
                            qs.stringify(
                                this.form
                            )
                        ).then(res => {
                            if(res.status==200)
                            {
                                this.$notify({
                                    title: 'Success',
                                    message: 'Submitted successfully',
                                    offset: 100
                                })
                                this.form={
                                    email:'',
                                }
                            }else{
                                this.$notify({
                                    title: 'Failure',
                                    message: 'Submission Failed',
                                    offset: 100
                                });
                            }
                        })
                    })
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.con{
    width:100%;
    animation: down 2s linear;
    @keyframes down {
        from{
            transform: translateX(-30px);
        }
        to{
            transform: translateX(0);
        }
    }
    .banner{
        width:100%;
        overflow: hidden;
        img{
            width:100%;
            object-fit: cover;
            display: block;
            animation: big 1s linear forwards;
        }
        @keyframes big {
            from{
                transform: scale(1.1);
            }
            to{
                transform: scale(1);
            }
        }
    }
    .main{
        width:1280px;
        margin: 0 auto;
        border-top: 1px solid rgba(0,0,0,.1);
        display: flex;
        flex-direction: row;
        padding-bottom: 60px;
        .contact{
            width:1280px;
            padding-top: 30px;
            margin: 0 auto;
            .title{
                text-align: center;
                font-family: Calibri;
                font-size: 25px;
                text-transform: uppercase;
                margin-block-end: 0.5em;
            }
            .lines{
                width:100%;
                text-align: center;
                display: flex;
                flex-direction: column;
                align-items: center;
                span{
                    display: inline-block;
                    width:12px;
                    height:1px;
                    background-color: rgba(0,0,0,.6);
                    margin-top:5px;
                }
                .t{
                    width:8px;
                    background-color: rgba(0,0,0,.3);
                }
            }
            .t{
                font-family:Calibri;
                font-size: 30px;
                span{
                    margin-left: 40px;
                }
            }
            .mainInfo{
                width:100%;
                margin-top: 30px;
                display: flex;
                flex-direction: row;
                .m1{
                    width:40%;
                    display: flex;
                    flex-direction: column;
                    p{
                        padding-top: 15px;
                        padding-left: 20px;
                        font-family: "Fira Code Light";
                        font-weight: lighter;
                        transition: all 2s;
                    }
                    img{
                        transition: all 2s;
                    }
                    .item{
                        width:100%;
                        display: flex;
                        flex-direction: row;
                        margin-top: 30px;
                        cursor: pointer;
                        align-items: center;
                        img{
                            height:40px;
                            border: 1px solid #F4A000;
                            padding: 10px 10px;
                        }
                    }
                    .item2{
                        width:100%;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        margin-top: 30px;
                        .ia{
                            display: flex;
                            flex-direction: row;
                            cursor: pointer;
                        }
                        .ia:hover{
                            p{
                                color:#F4A000;
                            }
                            img{
                                transform: rotate(360deg);
                            }
                        }
                    }
                    .item:hover{
                        p{
                            color:#F4A000;
                        }
                        img{
                            transform: rotate(360deg);
                        }
                    }
                }
                .form{
                    width:55%;
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    margin-top: 20px;
                    justify-content: space-between;
                    margin-left: 5%;
                    input{
                        width:46%;
                        height:35px;
                        border: 1px solid #D1D1D1;
                        margin-top: 30px;
                        text-indent: 10px;
                    }
                    input:focus{
                        outline: none;
                    }
                    textarea{
                        width:100%;
                        margin-top: 30px;
                        height:300px;
                        text-indent: 10px;
                        resize: none;
                    }
                    textarea:focus{
                        outline: none;
                    }
                }
            }
            .btn2{
                margin-left: 50%;
            }
            text-align: center;

        }
    }
    @media screen and (max-width:450px) {
        .banner {
            img {
                height: 300px;
            }
        }
        .main{
            width:95%;
            .contact{
                width:100%;
                .t{
                    line-height:50px;
                    font-size: 25px;
                    span{
                        margin-left: 0;
                    }
                }
                .mainInfo{
                    flex-direction: column;
                    .m1{
                        width:100%;
                    }
                    .item2{
                        margin-top: 0;
                        flex-direction: column;
                        .ia{
                            margin-top: 30px;
                        }
                    }
                    .form{
                        margin-top: 30px;
                        width:100%;
                        margin-left: 0;
                        input{
                            width:100%;
                        }
                    }
                }
                .btn2{
                    margin-left: 0;
                    margin-top: 30px;
                }
            }
        }
    }
}
</style>